<ac-form *ngIf="dialogConfig.ready" #operatorConnectForm
         [formModel]="tenant"
         [formSchema]="operatorConnectSchema"
         [isEdit]="true"
         [validateAuxiliaryForm]="validateAuxiliaryForm"
         formModelName="tenant">

    <div class="flexColumnParent oc-form-content">
<!--        <network-operator-connect-action-buttons class="flexItem" [tenant]="spAttachedTenant"></network-operator-connect-action-buttons>-->

        <operator-connect-menu class="flexItemBiggest"
                               [model]="tenant"
                               parentName="operatorConnectInfo"
                               [tenantFormSettings]="operatorConnectForm.formSettings"
                               [errors]="errors"
                               [availableNodesList]="['operatorContacts', 'offers']">
        </operator-connect-menu>
    </div>

</ac-form>
